import utils from '@/utils'
import api from '@core/api/'
import session from '@/utils/session'
// import storage from '@/utils/storage'

export default {
  state: {
    userInfo: {},
    versionNameList: ['AREA'],
    freshState: true,
    sideSwitch: false,
    dictionaryList: [ ],
    platformStr: {}// 产品平台对应的用户信息——用于工作流请求等
  },
  getters: {
    versionNameList: state => {
      return state.versionNameList
    },
    sideSwitch: state => {
      return state.sideSwitch
    },
    userInfo: state => {
      return state.userInfo
    },
    platformStr: state => {
      return state.platformObj
    }
  },
  mutations: {
    setSideSwitch (state, data) {
      state.sideSwitch = data
      console.log(state.sideSwitch, 'sideSwitch')
    },
    setUserInfo (state, data) {
      const userInfo = Object.assign({}, data)
      // 系统管理员
      userInfo.isSuperAdmin = userInfo.roleCode.findIndex(role => role === 'SUPER_ADMIN') !== -1
      // 运营公司超级管理员或系统超级管理员
      // userInfo.isSuperAdmin = (userInfo.roleCode === 'enterpriseManager' && userInfo.enterpriseId === 1) || userInfo.isSystemAdmin
      // 企业最大管理员
      userInfo.areaId = userInfo.userAreaId
      state.userInfo = userInfo
    },
    setPlatformStr (state, data) {
      // 根据获取当前用户的平台信息，设置cookie
      // 当前逻辑已修改，根据单点登录获取的cookie获取登录信息
      let param = {
        t: Date.now(),
        rgId: 1,
        parkId: 1
      }
      api.deviceService.getPingAnCookie(param).then(res => {
        if (res.code === '200') {
          let cookie = res.body
          // console.log('getToken:', this.Token)
          cookie = 'passport-sso=' + cookie
          document.cookie = cookie
          api.platGateway.getPlatCookie().then(res => {
            if (res.status === 'SUCCESS') {
              let platToken = res.data
              document.cookie = 'access_token=' + platToken.access_token + '; path=/'
              document.cookie = 'token_type=' + platToken.token_type + '; path=/'
            }
          })
          // 请求平台获取token
          sessionStorage.setItem('paicCookie', cookie)
        }
      })
    }
  },
  actions: {
    getClassTypeTree ({ commit }, data) {
      return new Promise((resolve, reject) => {
        const params = {
          t: Date.now(),
          usestatue: true
        }
        if (data) {
          params.classType = data
        }
        api.deviceService.getClassTree(params)
          .then(res => {
            console.log(res, '所属系统的返回')
            if (res && res.code === '9999') {
              const classtypeList = res.data
              resolve(utils.treeDataTranslate(classtypeList, 'bizid'))
            } else {
              resolve(res.data)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 数据字典
    getDictionaryList ({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        // const dictionaryList = parameterList.state.dictionaryList || []
        // const dictionaryList = storage.getSession('dictionaryList') || []
        var dictionaryList = state.dictionaryList
        // if (!dictionaryList) {
        //   dictionaryList = session.get('dictionaryList') || []
        //   // dictionaryList = JSON.parse(sessionStorage.getItem('dictionaryList'))
        // }
        if (dictionaryList.length === 0) {
          let param = {
            usestatue: true,
            rgId: 1,
            t: Date.now(),
            parkId: 1
          }
          api.deviceService.getDictionaryList(param)
            .then(res => {
              console.log(res, '没有没有')
              if (res.code === '9999') {
                console.log('来了这里0000')
                var menuList = res.attributes.menuList
                utils.treeDataTranslate(menuList, 'id')
                var list = []
                const str = data || 'assets'
                console.log(str, 'str0000000000000')
                menuList.forEach(e => {
                  if (e.dictCode === str) {
                    list.push(e)
                  }
                })
                // commit('SET_CARDPARAMENT', menuList)
                // storage.removeSession('dictionaryList')
                console.log('存储')
                // session.set('dictionaryList', menuList)
                // sessionStorage.setItem('dictionaryList', JSON.stringify(menuList))
                if (list && list.length > 0) {
                  console.log(list[0].children, 'list[0].children')
                  resolve(list[0].children)
                } else {
                  resolve([])
                }
                menuList = null
                list = null
              } else {
                resolve(res.data)
              }
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log('有')
          var list1 = []
          dictionaryList.forEach(e => {
            if (e.dictCode === data) {
              list1.push(e)
            }
          })
          dictionaryList = null
          if (list1 && list1.length > 0) {
            resolve(list1[0].children)
          } else {
            resolve(null)
          }
          list1 = null
        }
      })
    },
    fetchUserInfo ({commit}) {
      return new Promise((resolve, reject) => {
        const params = {
        }
        console.log('......3..........')
        api.userService.getUserInfo(params).then(data => {
          if (!data.errorMessage) {
            commit('setUserInfo', data.body)
            commit('setPlatformStr', data.body)
            // 根据用户的管理范围 设置园区list
            commit('setParkId', session.get('parkId') || data.body.parkList[0].id)
            commit('setParkList', data.body.parkList)
            resolve()
          } else {
            // utils.logout(true)
            reject(new Error())
          }
        }).catch(err => {
          console.log('......4..........')
          // utils.logout(true)
          console.log(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/area-base/store/common.js